import {connect} from 'react-redux';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Col, Row} from "antd";
import * as formTypes from "../../../constants/formtypes";
import * as translations from "../../../constants/translations";
import * as APP_CONFIG from "../../../constants/config";
const {benchmarkApi} = APP_CONFIG;


class LocationEdit extends Component {

    static propTypes = {
        match: PropTypes.shape({
            params: PropTypes.shape({
                id: PropTypes.string.isRequired
            }).isRequired
        }).isRequired
    };

    state = {
        data: 'not loaded'
    };

    formFieldTypes = {
        "Id": formTypes.NUMBER,
        "Name": formTypes.TEXT,
        "CompletionDate": formTypes.TEXT,
        "Street": formTypes.TEXT,
        "Number": formTypes.TEXT,
        "PostalCode": formTypes.TEXT,
        "Latitude": formTypes.FLOAT,
        "Longitude": formTypes.FLOAT,
        "City": formTypes.TEXT,
        "Organisation": formTypes.TEXT,
        "CustomerNr": formTypes.TEXT,
        "OrganisationType": formTypes.TEXT,
        "Led": formTypes.NUMBER,
        "LedOutside": formTypes.NUMBER,
        "LedReduction": formTypes.NUMBER,
        "Reach": formTypes.NUMBER,
    };

    componentDidMount = async () => {
        await this.loadData(this.props.match.params.id);
    };

    componentWillReceiveProps = async (nextProps) => {
        if(this.props.match.params.id !== nextProps.match.params.id)
            await this.loadData(nextProps.match.params.id);
    };

    loadData = async (id) => {
        const request = await fetch(`${benchmarkApi}locations/${id}`);
        const data = await request.json();
        this.setState({data});
    };

    renderCol = (key, val) => {
        return <Row gutter={{xs: 0, md: 1}}>
            <Col xs={24} md={8}>{translations.location[key]}</Col>
            <Col xs={24} md={15}>{val}</Col>
        </Row>;
    }

    render() {
        const {data} = this.state;
        return (
            <div>
                {Object.keys(data).map((key) => this.renderCol(key, data[key]))}
            </div>
        );
    }
}

const mapStateToProps = (state) => {return {}};

export default connect(mapStateToProps)(LocationEdit);



// WEBPACK FOOTER //
// ./src/components/baseinfo/locations/edit.js